import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "formgrid grid" }
const _hoisted_2 = { class: "col-12 md:col-4 lg:col-3 p-fluid field" }
const _hoisted_3 = { class: "col-12 md:col-4 lg:col-3 p-fluid field" }
const _hoisted_4 = { class: "col-12 md:col-4 lg:col-3 flex flex-column justify-content-end field" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = {
  key: 0,
  class: "grid formgrid"
}
const _hoisted_8 = { class: "col-12 md:col-4 xl:col-2 p-fluid field" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = { class: "col-12 md:col-4 xl:col-2 p-fluid field" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = { class: "col-12 md:col-6 lg:col-4 xl:col-3 driver-box" }
const _hoisted_13 = { class: "m-1 p-2 border-round border-1 border-orange-500 shadow-1" }
const _hoisted_14 = { class: "flex justify-content-between" }
const _hoisted_15 = { class: "detail font-bold" }
const _hoisted_16 = { class: "detail flex justify-content-between" }
const _hoisted_17 = { style: {"font-size":"1rem"} }
const _hoisted_18 = { class: "detail flex justify-content-between" }
const _hoisted_19 = { class: "detail flex justify-content-between" }
const _hoisted_20 = { class: "detail" }
const _hoisted_21 = { class: "detail" }
const _hoisted_22 = { class: "detail" }
const _hoisted_23 = { class: "flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "m-3" }, {
    title: _withCtx(() => _cache[4] || (_cache[4] = [
      _createTextVNode("Performance Report")
    ])),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { for: "selectedDate" }, "ระบุวันที่รายงาน", -1)),
          _createVNode(_component_Calendar, {
            id: "selectedDate",
            modelValue: _ctx.screen.selectedDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.screen.selectedDate) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { for: "salesOffice" }, "ระบุ Sales Office", -1)),
          _createVNode(_component_MultiSelect, {
            modelValue: _ctx.screen.salesOffices,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.screen.salesOffices) = $event)),
            options: _ctx.salesOffices,
            optionLabel: "description",
            optionValue: "code"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            icon: "pi pi-search",
            onClick: _ctx.queryReport,
            loading: _ctx.isLoading
          }, null, 8, ["onClick", "loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_DataView, {
            value: _ctx.filteredResult,
            layout: "grid"
          }, {
            header: _withCtx(() => [
              (_ctx.results.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _createVNode(_component_Dropdown, {
                          modelValue: _ctx.selectedSort,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSort) = $event)),
                          options: _ctx.sortOptions,
                          optionValue: "code",
                          optionLabel: "description",
                          id: "sortDropdown",
                          onChange: _ctx.onSelectSort
                        }, null, 8, ["modelValue", "options", "onChange"]),
                        _cache[7] || (_cache[7] = _createElementVNode("label", { for: "sortDropdown" }, "Sort by", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, [
                        _createVNode(_component_InputText, {
                          id: "searchString",
                          modelValue: _ctx.searchString,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchString) = $event)),
                          class: "p-inputtext-sm"
                        }, null, 8, ["modelValue"]),
                        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "searchString" }, "ค้นหา", -1))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            empty: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("ไม่พบข้อมูล")
            ])),
            grid: _withCtx((props) => [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("b", null, "Shipment No:", -1)),
                      _createTextVNode(_toDisplayString(parseInt(props.data.shipmentNo)), 1)
                    ]),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(props.data.office), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(parseInt(props.data.driver)) + " : " + _toDisplayString(props.data.driverName), 1),
                    _createElementVNode("span", null, _toDisplayString(props.data.startTime) + " - " + _toDisplayString(props.data.endTime), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", null, " จำนวนเอกสาร : " + _toDisplayString(props.data.docSuccess) + " / " + _toDisplayString(props.data.docAssign), 1),
                    _createElementVNode("span", null, _toDisplayString((props.data.duration / 3600).toFixed(0)) + " ชั่วโมง " + _toDisplayString(((props.data.duration % 3600) / 60).toFixed(0)) + " นาที ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", null, " จำนวนเคส : " + _toDisplayString(props.data.caseSuccess) + " / " + _toDisplayString(props.data.caseAssign), 1),
                    _createElementVNode("span", null, "จำนวนลูกค้า : " + _toDisplayString(props.data.customers), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, "Capacity : " + _toDisplayString(props.data.capacity), 1),
                  _createElementVNode("div", _hoisted_21, " Capacity Used : " + _toDisplayString(props.data.capacityAssign) + " (" + _toDisplayString(props.data.capacityPercent) + " %) ", 1),
                  _createElementVNode("div", _hoisted_22, " Case/manday : " + _toDisplayString(_ctx.formatQuantity(
                        props.data.caseAssign / (props.data.helpers + 1)
                      )), 1)
                ])
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", null, "จำนวนเอกสารทั้งหมด " + _toDisplayString(_ctx.results.length) + " เอกสาร", 1),
                _createVNode(_component_Button, {
                  icon: "pi pi-download",
                  label: "Download Excel",
                  class: "p-button-success",
                  onClick: _ctx.downloadExcel,
                  disabled: _ctx.results.length === 0
                }, null, 8, ["onClick", "disabled"])
              ])
            ]),
            _: 2
          }, 1032, ["value"])
        ])
      ])
    ]),
    _: 1
  }))
}